import React from 'react';
import { View, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';

export default function ClassBookDateNav({
  onShiftDays,
  disabled = false,
  iconColor = '#d4af37',
  buttonBackground = '#faf8f4',
  borderColor = 'rgba(0,0,0,0.12)',
}) {
  const shift = (days) => {
    if (disabled) return;
    onShiftDays?.(days);
  };

  return (
    <View
      style={styles.row}
      {...(Platform.OS === 'web' ? { dataSet: { classBookDateNav: 'true' } } : {})}
    >
      <TouchableOpacity
        style={[styles.btn, { backgroundColor: buttonBackground, borderColor }]}
        onPress={() => shift(-7)}
        disabled={disabled}
        accessibilityLabel="Previous week"
        {...(Platform.OS === 'web' ? { dataSet: { classBookDateNavBtn: 'true' } } : {})}
      >
        <MaterialIcons name="fast-rewind" size={24} color={iconColor} />
      </TouchableOpacity>
      <TouchableOpacity
        style={[styles.btn, { backgroundColor: buttonBackground, borderColor }]}
        onPress={() => shift(-1)}
        disabled={disabled}
        accessibilityLabel="Previous day"
        {...(Platform.OS === 'web' ? { dataSet: { classBookDateNavBtn: 'true' } } : {})}
      >
        <MaterialIcons name="chevron-left" size={26} color={iconColor} />
      </TouchableOpacity>
      <TouchableOpacity
        style={[styles.btn, { backgroundColor: buttonBackground, borderColor }]}
        onPress={() => shift(1)}
        disabled={disabled}
        accessibilityLabel="Next day"
        {...(Platform.OS === 'web' ? { dataSet: { classBookDateNavBtn: 'true' } } : {})}
      >
        <MaterialIcons name="chevron-right" size={26} color={iconColor} />
      </TouchableOpacity>
      <TouchableOpacity
        style={[styles.btn, { backgroundColor: buttonBackground, borderColor }]}
        onPress={() => shift(7)}
        disabled={disabled}
        accessibilityLabel="Next week"
        {...(Platform.OS === 'web' ? { dataSet: { classBookDateNavBtn: 'true' } } : {})}
      >
        <MaterialIcons name="fast-forward" size={24} color={iconColor} />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    marginBottom: 12,
    backgroundColor: 'transparent',
  },
  btn: {
    width: 40,
    height: 40,
    borderRadius: 8,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
